import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthUserProvider } from "./context/AuthUserContext";
import { AppWrapper } from "./components/common/PageMeta";
import AutoTranslate from "./components/common/AutoTranslate";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppWrapper>
      <ThemeProvider>
        <LanguageProvider>
          <AuthUserProvider>
            <AutoTranslate />
            <App />
          </AuthUserProvider>
        </LanguageProvider>
      </ThemeProvider>
    </AppWrapper>
  </React.StrictMode>
);
